<template>
    <div class="loan-eligibility" v-if="current_eligibility && current_eligibility_pl">
        <b-card no-body>
            <b-card-header class="border-0">
                <b-row align-v="center">
                    <b-col cols="12">
                        <h3 class="mb-0">
                            Loan Eligibility
                        </h3>
                    </b-col>
                    <!-- <b-col cols="6">
                        <el-button class="float-right text-muted py-0" type="text" disabled>View More</el-button>
                    </b-col> -->
                </b-row>
            </b-card-header>
            <div class="eligiblity-table">
                <el-table :data="tableData" empty-text="No Data" style="width: 100%" v-loading="is_loading_table">
                    <el-table-column prop="product" label="Product" min-width="130">
                        <template v-slot="{ row }">
                            <span class="text-truncate">{{ row.product }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="loan" label="Loan" min-width="110" width="auto">
                        <template v-slot="{ row }">
                            <span v-if="row.loan === 'N/A'">N/A</span>
                            <span v-else>RM{{ row.loan | moneyFormatter }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="status" label="status" width="auto">
                        <template v-slot="{ row }">
                            <span class="text-success text-xs" v-if="row.status === 'Eligible'">Eligible</span>
                            <span class="text-danger text-xs" v-if="row.status === 'Not Eligible'">Not Eligible</span>
                            <span class="text-muted text-xs" v-if="row.status === 'N/A'">N/A</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <b-card-footer class="col-12 d-flex justify-content-center">
                <b-button @click="$refs.drawer_solution_scenario.viewSolutionScenario()" block variant="primary"
                    :disabled="is_loading_table">Select Product</b-button>
            </b-card-footer>
        </b-card>

        <!-- Drawer Solution Scenario -->
        <drawer-solution-scenario ref="drawer_solution_scenario"
            :product_details="tableData"></drawer-solution-scenario>
    </div>
</template>
<script>
import { Card, Button, Table, TableColumn } from 'element-ui'
import DrawerSolutionScenario from '@/views/CustomerProfile/CustomerProfileDetails/OffCanvasDetails/DrawerSolutionScenario/DrawerSolutionScenario'
import { mapState } from 'pinia'
import { useCustomerStore } from '@/stores/customerStore'
import { useAuthStore } from '@/stores/authStore'
import { axios, services, getHeader, notifyFunctionMixin, helperFunctionMixin } from '@/assets/js/httpImports.js'

export default {
    name: 'loan-eligibility',
    components: {
        DrawerSolutionScenario,
        [Card.name]: Card,
        [Button.name]: Button,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
    },
    mixins: [notifyFunctionMixin, helperFunctionMixin],
    data() {
        return {
            tableData: [
                {
                    product: 'Property',
                    loan: 'N/A',
                    status: 'N/A',
                    is_not_applicable: false,
                },
                {
                    product: 'Mortgage',
                    loan: 'N/A',
                    status: 'N/A',
                    is_not_applicable: false,
                },
                {
                    product: 'Personal Loan',
                    loan: 'N/A',
                    status: 'N/A',
                    is_not_applicable: false,
                },
                {
                    product: 'Insurance',
                    loan: 'N/A',
                    status: 'N/A',
                    is_not_applicable: false,
                },
                {
                    product: 'Refinance',
                    loan: 'N/A',
                    status: 'N/A',
                    is_not_applicable: false,
                },
                {
                    product: 'Other Loan',
                    loan: 'N/A',
                    status: 'N/A',
                    is_not_applicable: false,
                },
                {
                    product: 'Solicitor',
                    loan: 'N/A',
                    status: 'N/A',
                    is_not_applicable: false,
                }
            ],
            max_personal_loan_amount: 0,
            is_loading_table: true,
            max_amounts: [],
        }
    },
    computed: {
        ...mapState(useCustomerStore, ['getEligibilityPL', 'current_eligibility', 'current_eligibility_pl']),
        ...mapState(useAuthStore, ['auth_user'])
    },
    watch: {
        current_eligibility: {
            handler(newVal, oldVal) {
                if (newVal) {
                    this.tableData = []
                    this.tableData.push(
                        {
                            product: 'Property',
                            loan: this.current_eligibility.max_eligibility,
                            status: this.current_eligibility.max_eligibility > 0 ? 'Eligible' : 'Not Eligible',
                            is_not_applicable: !this.auth_user.subscription.privileges.scpk_la_property,
                        },
                        {
                            product: 'Mortgage',
                            loan: this.current_eligibility.max_eligibility,
                            status: this.current_eligibility.max_eligibility > 0 ? 'Eligible' : 'Not Eligible',
                            is_not_applicable: !this.auth_user.subscription.privileges.scpk_la_mortgage,
                        },
                        {
                            product: 'Personal Loan',
                            loan: 'N/A',
                            status: 'N/A',
                            is_not_applicable: !this.auth_user.subscription.privileges.scpk_la_personal_loan,
                        },
                        {
                            product: 'Insurance',
                            loan: 'N/A',
                            status: 'N/A',
                            is_not_applicable: !this.auth_user.subscription.privileges.scpk_la_insurance,
                        },
                        {
                            product: 'Refinance',
                            loan: 'N/A',
                            status: 'N/A',
                            is_not_applicable: !this.auth_user.subscription.privileges.scpk_la_refinance,
                        },
                        {
                            product: 'Other Loan',
                            loan: 'N/A',
                            status: 'N/A',
                            is_not_applicable: !this.auth_user.subscription.privileges.scpk_la_other_loan,
                        },
												{
														product: 'Solicitor',
														loan: 'N/A',
														status: 'N/A',
														is_not_applicable: !this.auth_user.subscription.privileges.scpk_la_solicitor,
                        },
												{
														product: 'MHLV',
														loan: 'N/A',
														status: 'N/A',
														is_not_applicable: !this.auth_user.subscription.privileges.scpk_la_mhlv,
                      	}
                    )
                    this.tableData = this.tableData.filter((item) => {
                        return !item.is_not_applicable
                    })
                    this.is_loading_table = false
                    this.refreshPersonalLoan()
                }
            }
        }
    },
    methods: {
        async refreshPersonalLoan() {
            await this.getEligibilityPL();
            let eligiblePL = 0
            const prefferedBanks = this.auth_user.subscription.scrb_banks
            if (prefferedBanks.length > 0) {
                prefferedBanks.forEach((bank) => {
                    this.current_eligibility_pl.bank_eligibilities.forEach((item, index) => {
                        if (item.bank_code === bank.bank_code) {
                            if (parseFloat(item.bank_loan_eligibility_amount) > parseFloat(eligiblePL)) {
                                if (parseFloat(item.bank_loan_eligibility_amount) > parseFloat(item.bank_max_loan_amount)) {
                                    eligiblePL = item.bank_max_loan_amount
                                } else {
                                    eligiblePL = item.bank_loan_eligibility_amount
                                }
                            }
                        }
                    })
                })
            } else {
                this.current_eligibility_pl.bank_eligibilities.forEach((item, index) => {
                    if (parseFloat(item.bank_loan_eligibility_amount) > parseFloat(eligiblePL)){
                        if (parseFloat(item.bank_loan_eligibility_amount) > parseFloat(item.bank_max_loan_amount)) {
                            eligiblePL = item.bank_max_loan_amount
                        } else {
                            eligiblePL = item.bank_loan_eligibility_amount
                        }
                    }
                })
            }
            this.current_eligibility_pl.max_eligibility = eligiblePL
            if (!_gHlp.checkAccess(['c_customer__personal_loan_eligible'])) return;
            this.tableData.find((item) => {
                if (item.product === 'Personal Loan') {
                    item.loan = eligiblePL
                    item.status = eligiblePL > 0 ? 'Eligible' : 'Not Eligible'
                }
            })
        },
        getPersonalLoanEligibilities() {
            axios.get(services.customer + 'customer/' + this.$route.params.customer_id + '/dsr.eligibilities?formula=PL', { headers: getHeader() })
                .then(res => {
                    this.personal_loan_bank_eligibilities = res.data.data.bank_eligibilities
                    this.personal_loan_bank_eligibilities.forEach((bank) => {
                        if (bank.bank_max_loan_amount > this.max_personal_loan_amount) {
                            this.max_personal_loan_amount = bank.bank_max_loan_amount
                        }
                    })
                    this.tableData.push(
                        {
                            product: 'Property',
                            loan: this.current_eligibility.max_eligibility,
                            status: this.current_eligibility.max_eligibility > 0 ? 'Eligible' : 'Not Eligible'
                        },
                        {
                            product: 'Mortgage',
                            loan: this.current_eligibility.max_eligibility,
                            status: this.current_eligibility.max_eligibility > 0 ? 'Eligible' : 'Not Eligible'
                        },
                        {
                            product: 'Personal Loan',
                            loan: this.max_personal_loan_amount,
                            status: this.max_personal_loan_amount > 0 ? 'Eligible' : 'Not Eligible'
                        }
                    )
                    this.is_loading_table = false
                })
                .catch(e => {
                    this.is_loading_table = false
                    this.errorFunction(e)
                })
        }
    }
}
</script>